<template  >
<v-layout column fill-height="">

    <not-toolbar-sub :not="not"/>  
    <!-- //access page -->
    <not-access-deny-page 
        v-if="!accessPage"
        :not="not"
        :notShow="true"/> 
    <!-- //page -->
    <v-layout column="" fill-height="" v-else class="ma-10 "> 

        <not-page-spinner 
            :notShow="true" 
            :not="not"
            v-if="!page_show"/> 
        <div v-else>
            <!-- CANDIDATES GRAPH -->
            <!-- <v-card class="my-5">
                <v-toolbar
                    color="primary"
                    dark
                    >  
                    <v-toolbar-title>CANDIDATES RESULTS</v-toolbar-title> 
                    <v-spacer></v-spacer> 
                </v-toolbar>
                <v-list two-line="">
                    <template v-for="(item, index) in not.CALCULATE_CANDIDATES_RESULTS(null,resultsType,true)">
                      
                        <v-divider 
                            :key="index"
                            :inset="item.inset"
                            ></v-divider>

                        <v-list-item 
                            :key="item.title" 
                            @click=""
                            >
                            <v-list-item-avatar class="my-0">
                                <div v-if="item.image_link">
                                    <v-list-item-avatar size="50" class="ma-0">
                                        <v-img :src="item.image_link" />  
                                    </v-list-item-avatar>
                                </div>
                                <div v-else>
                                    <v-list-item-avatar size="50" color="b2" class="ma-0"> 
                                    </v-list-item-avatar>
                                </div>
                            </v-list-item-avatar>

                            <v-list-item-content> 
                                <div>
                                    <v-progress-linear
                                        :color="item.party_color?item.party_color:' b2'"
                                        height="25"
                                        :value="item.votes"
                                        reactive  :striped="false">
                                        <template v-slot="{ value }">
                                            <strong class=""> {{item.name}} </strong>
                                        </template>  
                                    </v-progress-linear> 
                                </div> 
                            </v-list-item-content>
                            <v-list-item-action>
                                <div class="not-w60" > 
                                    {{ item.votes.toFixed(2) }}% 
                                </div>
                            </v-list-item-action>
                        </v-list-item>
                    </template>
                </v-list>
            </v-card> -->

            <!-- RESULTS TOOLBAR -->
            <v-toolbar color="primary" dark="" tile=""  >
                <v-toolbar-title>
                RESULTS GRAPH
                </v-toolbar-title>
                <v-spacer></v-spacer>  
                <v-menu bottom left 
                    v-model="menuGraph"
                    :close-on-content-click="false"
                    :nudge-width="250">
                    <template v-slot:activator="{ on }">
                        <v-btn class="mr-2"
                            dark outlined="" 
                            rounded=""
                            icon
                            v-on="on" >
                            <v-icon>mdi-tune</v-icon>
                        </v-btn>
                    </template>

                    <v-card>
                        <v-card-title primary-title>
                            <v-layout >
                                CUSTOMIZE GRAPH
                                <v-spacer></v-spacer>
                                <v-btn icon="" @click="menuGraph=false"><v-icon>close</v-icon></v-btn>
                            </v-layout>
                        </v-card-title>
                        <v-card-text>
                            <v-list subheader="" dense="">
                                <div v-for="(item, i) in xHeader_graph" :key="i">
                                    <v-subheader v-if="item.title">{{item.name}}</v-subheader>
                                    <v-list-item v-else  @click="onCustomizeGraph(item,i)" >
                                        <v-list-item-icon><v-icon>{{item.show?"mdi-check-box-outline":"mdi-checkbox-blank-outline"}}</v-icon></v-list-item-icon>
                                        <v-list-item-title>{{item.name}}</v-list-item-title>
                                    </v-list-item> 
                                </div> 
                            </v-list> 
                            <v-layout >
                                <v-spacer></v-spacer>
                                <v-btn @click="menuGraph = false" color="primary">OK</v-btn>
                            </v-layout>
                        </v-card-text> 
                    </v-card>  
                </v-menu>

            
    
            </v-toolbar> 
            <!-- RESULTS GRAPH -->
            <v-card class="px-5">
                <!-- //Show ghp -->
                <not-page-spinner 
                    :notShow="true" 
                    :not="not"
                    v-if="!page_show_results"/> 
                <div v-else-if="JOINED_results">
                    <div class="py-4">
                        Results for: All {{selectedGraph()}}  
                    </div>
                    <div v-if="not.TEXT_UP(selectedGraph())==='CANDIDATES'">
                        <not-chart-bar
                        :notShow="true"
                        :not = "not"
                        :notUnit="selectedGraph(null,'unit')"
                        :notHeight="'500px'"
                        :notChartData="paginedChartData"/> 
                    </div>
                    <div v-else>
                        <not-chart-bar2
                        :notShow="true"
                        :not = "not"
                        :notUnit="selectedGraph(null,'unit')"
                        :notHeight="'500px'"
                        :notChartData="paginedChartData"/> 
                    </div>
                    
                    <v-divider></v-divider>
                    <v-layout  >
                        <v-spacer></v-spacer>
                        <not-pager
                            v-model="pagerGraph"
                            :not="not" 
                            :notShow="true" 
                            :notData="chartData()" 
                            notTitle="Bars per page"/>  
                    </v-layout>  
                </div>
            </v-card>
    
            <!-- RESULTS TOOLBAR -->
            <v-toolbar class="mt-5" color="primary" dark="" tile=""  >
                <v-toolbar-title>
                RESULTS TABLE
                </v-toolbar-title>
                <v-spacer></v-spacer>   
                <v-menu bottom left 
                    v-model="menuFilter"
                    :close-on-content-click="false"
                    :nudge-width="250">
                    <template v-slot:activator="{ on }">
                    <v-btn class="mr-2"
                        dark outlined="" rounded=""
                        icon
                        v-on="on"
                    >
                        <v-icon>mdi-tune</v-icon>
                    </v-btn>
                    </template>

                    <v-card>
                        <v-card-title primary-title>
                            <v-layout >
                                CUSTOMIZE RESULTS
                                <v-spacer></v-spacer>
                                <v-btn icon="" @click="menuFilter=false"><v-icon>close</v-icon></v-btn>
                            </v-layout>
                        </v-card-title>
                        <v-card-text>
                            <v-list subheader="" dense="">
                                <div v-for="(item, i) in xHeader_results" :key="i">
                                    <v-subheader v-if="item.title">{{item.name}}</v-subheader>
                                    <v-list-item v-else  @click="not.TABLE_HEADER_SELECTOR(xHeader_results,i)" >
                                        <v-list-item-icon><v-icon>{{item.show?"mdi-check-box-outline":"mdi-checkbox-blank-outline"}}</v-icon></v-list-item-icon>
                                        <v-list-item-title>{{item.name}}</v-list-item-title>
                                    </v-list-item> 
                                </div> 
                            </v-list> 
                            <v-layout >
                                <v-spacer></v-spacer>
                                <v-btn @click="menuFilter = false" color="primary">OK</v-btn>
                            </v-layout>
                        </v-card-text>
                        
                    </v-card> 
                </v-menu>   
            </v-toolbar> 
            <!-- RESULTS TABLE -->
            <v-card    >
                <!-- //Show res -->
                <not-page-spinner 
                    :notShow="true" 
                    :not="not"
                    v-if="!page_show_results"/> 
                <!-- //Res table -->
                <div v-else-if="JOINED_results"> 
                    <not-table-results2 class="not-fullwidth"
                        @viewItem="viewItem"
                        :not="not"
                        :notTitle="selectedGraph()"
                        :notShow="true"
                        :notItems="tableData"
                        :notHeaders="headerss('results')"/> 
                </div>
            </v-card> 
        </div>
    </v-layout>


    <!-- //CANDIDATE DIALOG -->
    <v-dialog
      v-model="dialog_candidate"
      width="1200"> 
      <v-card v-if="selectedViewItem" >
        <v-card-title 
          class="white headline "
          primary-title >
            <v-avatar
                size="15"
                class="mr-2"
                :color="selectedViewItem.party_color" > 
            </v-avatar>
          {{selectedViewItem.candidate_name}}
          <v-spacer></v-spacer>
            <v-btn
                icon=""
                :color="selectedViewItem.party_color?selectedViewItem.party_color:' primary'"
                text
                @click="dialog_candidate = false" >
                <v-icon>close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="pb-0">
            <v-row>
                <v-col sm="4">
                    <v-sheet v-if="selectedViewItem">
                        <v-img :src="selectedViewItem.image_link" />  
                    </v-sheet>
                </v-col>
                <v-col sm="8"> 
                    <v-card tile="" flat=""
                        class="not-fix-height" height="350">
                        <div v-for="(district, index) in candidate_district_results(selectedViewItem.code) " :key="index">
                            {{not.TEXT_UP(district.district_name)}}
                            <v-progress-linear
                                :color="selectedViewItem.party_color?selectedViewItem.party_color:' b2'"
                                height="50"
                                :value="district.votes_percent"
                                reactive  :striped="false">
                                <template v-slot="{ value }">
                                    {{value.toFixed(2)}}%
                                </template>  
                            </v-progress-linear> 
                            <!-- {{district}} -->
                        </div> 
                    </v-card> 
                </v-col>
            </v-row>
        </v-card-text>

        <v-divider></v-divider> 
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :color="selectedViewItem.party_color?selectedViewItem.party_color:' primary'"
            text
            @click="dialog_candidate = false"
          >
           Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- //DISTRICT DIALOG -->
    <v-dialog
      v-model="dialog_district"
      width="1200"> 
      <v-card v-if="selectedViewItem" >
        <v-card-title 
          class="white headline "
          primary-title >
            <v-avatar
                size="15"
                class="mr-2"
                :color="'primary'" > 
            </v-avatar>
          {{selectedViewItem.name}} {{selectedGraph()}}
          <v-spacer></v-spacer>
            <v-btn
                icon=""
                :color="'primary'"
                text
                @click="dialog_district = false" >
                <v-icon>close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="pb-0">
            <div class="not-f5">  
                The following results represent the percentage of total votes for {{not.TEXT_UP11(selectedViewItem.name)}} District received from each Candidate.
            </div>
            <v-row>
                <v-col sm="4">
                    <v-card height="100%" color="primary">
                        <v-layout fill-height="" justify-center="" align-center="">
                            <div class="not-f9 white--text">{{not.TEXT_UP(selectedViewItem.name.slice(0,2))}}</div>
                        </v-layout>
                    </v-card>
                </v-col>
                <v-col sm="8"> 
                    <v-card tile="" flat=""
                        class="not-fix-height" height="350">
                        <div v-for="(candidate, index) in candidate_results_by_location(selectedViewItem.code) " :key="index">
                            {{not.TEXT_UP(candidate.candidate_name)}} 
                            <v-layout align-center="">
                                
                                <v-avatar
                                    class="mr-2"
                                    size="80"
                                    :color="candidate.party_color?candidate.party_color:'primary'">
                                    <v-img  :src="candidate.image_link" />  
                                </v-avatar>
                                    
                                 
                                <v-progress-linear
                                    :color="candidate.party_color?candidate.party_color:'primary'"
                                    height="50"
                                    :value="candidate.votes_percent"
                                    reactive  :striped="false">
                                    <template v-slot="{ value }">
                                        {{value.toFixed(2)}}%
                                    </template>  
                                </v-progress-linear>  
                            </v-layout>
                        </div> 
                    </v-card> 
                </v-col>
            </v-row>
        </v-card-text>

        <v-divider></v-divider> 
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :color="'primary'"
            text
            @click="dialog_district = false"
          >
           Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- //REGION DIALOG -->
    <v-dialog
      v-model="dialog_region"
      width="1200"> 
      <v-card v-if="selectedViewItem" >
        <v-card-title 
          class="white headline "
          primary-title >
            <v-avatar
                size="15"
                class="mr-2"
                :color="'primary'" > 
            </v-avatar>
          {{selectedViewItem.name}} {{selectedGraph()}}
          <v-spacer></v-spacer>
            <v-btn
                icon=""
                :color="'primary'"
                text
                @click="dialog_region = false" >
                <v-icon>close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="pb-0">
            <div class="not-f5">  
                The following results represent the percentage of total votes for {{not.TEXT_UP11(selectedViewItem.name)}} Region received from each Candidate.
            </div>
            <v-row>
                <v-col sm="4">
                    <v-card height="100%" color="primary">
                        <v-layout fill-height="" justify-center="" align-center="">
                            <div class="not-f9 white--text">{{not.TEXT_UP(selectedViewItem.name.slice(0,2))}}</div>
                        </v-layout>
                    </v-card>
                </v-col>
                <v-col sm="8"> 
                    <v-card tile="" flat=""
                        class="not-fix-height" height="350">
                        <div v-for="(candidate, index) in candidate_results_by_location(selectedViewItem.code) " :key="index">
                            {{not.TEXT_UP(candidate.candidate_name)}} 
                            <v-layout justify-center="" align-center="">
                                
                                <v-avatar
                                    class="mr-2"
                                    size="80"
                                    :color="candidate.party_color?candidate.party_color:'primary'">
                                    <v-img  :src="candidate.image_link" />  
                                </v-avatar> 
                                <v-progress-linear
                                    :color="candidate.party_color?candidate.party_color:'primary'"
                                    height="50"
                                    :value="candidate.votes_percent"
                                    reactive  :striped="false">
                                    <template v-slot="{ value }">
                                        {{value.toFixed(2)}}%
                                    </template>  
                                </v-progress-linear>  
                            </v-layout>
                            <br>
                        </div> 
                    </v-card> 
                </v-col>
            </v-row>
        </v-card-text>

        <v-divider></v-divider> 
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :color="'primary'"
            text
            @click="dialog_region = false"
          >
           Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-layout>
</template>

<script> 

    let pageName = 'PresidentialResults' 
    let ACTION_TIME = 100
    export default{
        name: pageName,
        props:['not'],  
        data: () => ({ 
            page_show: false,  
            page_show_results: false, 
            page_Graph:1,
            menuGraph:false,
            menuFilter:false,
            pagerGraph:[],
            
            xHeader_graph:[  
                {id:1,name:"RESULTS FOR:",title:true},
                {id:2,type:"results",name:"Candidates",show:true}, 
                {id:3,type:"results",name:"Regions",show:false},
                {id:4,type:"results",name:"Districts",show:false}, 

                {id:1,name:"VOTES UNIT:",title:true},
                {id:3,type:"unit",name:"Number",show:false},
                {id:2,type:"unit",name:"Percentage",show:true},  
            ],
            xHeader_results:[ 
                {id:1,name:"General",title:true},
                {id:0,name:"Number",show:true},
                {id:0,name:"Votes",show:true}, 
                {id:26,name:"ACTION",show:true}, 

                {id:1,name:"Candidate",title:true},
                {id:0,name:"Candidate Name",show:true}, 
                {id:0,name:"Candidate Code",show:false}, 
                {id:0,name:"Candidate Gender",show:true},

                {id:1,name:"Party",title:true},
                {id:0,name:"Party Name",show:false}, 
                {id:0,name:"Party Short Name",show:true}, 
                {id:0,name:"Party Code",show:false},  

                {id:1,name:"Region",title:true},
                {id:0,name:"Region Name",show:true}, 
                {id:0,name:"Region Code",show:false}, 
                {id:0,name:"District Name",show:true}, 
                {id:0,name:"District Code",show:false}, 
                {id:0,name:"Constituency Name",show:true}, 
                {id:0,name:"Constituency Code",show:false},  
 
                {id:0,name:"Added By",show:false}, 
                {id:0,name:"Added At",show:false}, 
                {id:0,name:"Updated At",show:false},
                
            ],
            dialog_candidate:false,
            dialog_region:false,
            dialog_district:false,
            selectedViewItem:null
            
        }),  
        created(){
             this.EventBus.$on('notYesDialog', this.notYesDialog); 
        },
        mounted() {   
            this.pageLoad(1000) 
        },
        computed:{ 
            accessCentres(){
                return permission=>{
                    if (permission === "read") {
                        return this.not.ACCESS_READ("graph results") 
                    }else if (permission === "write") {
                        return this.not.ACCESS_WRITE("graph results") 
                    }else if (permission === "edit") {
                        return this.not.ACCESS_EDIT("graph results") 
                    }else if (permission === "delete") {
                        return this.not.ACCESS_DELETE("graph results") 
                    }else{
                        return false
                    }
                }
            },
            accessPage(){
                return this.not.ACCESS_PAGE(this.$route.name)
            },
            us(){
                return this.not.us
            },
            pagerss(){
                return this.not.PAGER.list
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },
            candidates(){
                return this.$store.getters.getCandidates
            }, 
            resultsType(){
                let sw = this.submitResultsLevel 
                let type = ""
                if (this.not.TEXT_EQ(sw,'Districts')) {
                    type = 'district'
                }else if (this.not.TEXT_EQ(sw,'Constituencies')) {
                    type = 'constituency'
                }else if (this.not.TEXT_EQ(sw,'Wards')) {
                    type = 'ward'
                }else if (this.not.TEXT_EQ(sw,'Centres')) {
                    type = 'centre'
                } 
                return type
            }, 
            results(){
                return type=>{
                    return this.$store.getters.getResults(type)
                }
            },
            resultsDetails(){
                return type=>{
                    return this.$store.getters.getResultsDetails(type)
                }
            },
            submitLevel(){
                return this.$store.getters.getSubmitLevel
            },
            submitResultsLevel(){
                return this.$store.getters.getSubmitResultsLevel
            },
            regions(){
                return this.$store.getters.getRegions
            }, 
            districts(){
                return this.$store.getters.getDistricts
            }, 
            constituencies(){
                return this.$store.getters.getConstituencies
            }, 
            wards(){
                return this.$store.getters.getWards
            }, 
            centres(){
                return this.$store.getters.getCentres
            },  
            customResults(){
                let general = [ 
                    {id:1,name:"General",title:true},
                    {id:0,name:"Number",show:true}, 
                    {id:3,name:"Votes",show:true},
                    {id:26,name:"ACTION",show:true},   
                ]
                let candidate = [  
                    {id:1,name:"Candidate",title:true},
                    {id:2,name:"Candidate Name",show: true}, 
                    {id:2,name:"Candidate Gender",show: false},  
                    {id:9,name:"Party Name",show:false},
                    {id:10,name:"Party Short Name",show:true},   
                ]
                let region = [  
                    {id:12,name:"Region",title:true},
                    {id:13,name:"Region Name",show:true},  
                ]
                let district = [     
                    {id:16,name:"District Name",show:true},   
                ]
                let constituency = [    
                    {id:19,name:"Constituency Name",show:true},   
                ]
                let ward = [   
                    {id:22,name:"Ward Name",show:true},   
                ]
                let centre = [    
                    {id:25,name:"Centre Name",show:true},  
                ]
                let cResults = []
                let selected = this.selectedGraph()
                if (selected==="Candidates") {
                    cResults = [
                        ...general,
                        ...candidate
                    ]
                }else if (selected==="Regions") {
                    cResults = [
                        ...general,
                        ...region
                    ]
                }else if (selected==="Districts") {
                    cResults = [
                        ...general,
                        ...region,
                        ...district
                    ]
                }else{
                  cResults = [
                        ...general,
                        ...candidate,
                        ...region
                    ]  
                }

                return cResults
            },
            headers(){
                let hrs = []
                //general
                if (this.getShowCR('Number')) {
                    hrs.push({ text: 'NO.',align: 'left', value: 'no',sortable: true})
                }
                if (this.getShowCR('Level')) {
                    hrs.push({ text: 'LEVEL',align: 'left', value: 'level',sortable: true})
                }
                
                //candidate
                if (this.getShowCR('Candidate Name')) {
                    hrs.push({ text: 'CANDIDATE',align: 'left', value: 'candidateName',sortable: true},)
                }
                if (this.getShowCR('Candidate Code')) {
                    hrs.push({ text: 'CANDIDATE CODE',align: 'left', value: 'candidateCode',sortable: true},)
                }
                if (this.getShowCR('Candidate Gender')) {
                    hrs.push({ text: 'CANDIDATE GENDER',align: 'left', value: 'candidateGender',sortable: true},)
                }
                if (this.getShowCR('Candidate Age')) {
                    hrs.push({ text: 'CANDIDATE AGE',align: 'left', value: 'candidateAge',sortable: true},)
                }

                //Abserver
                
                if (this.getShowCR("Observer Name")) {
                    hrs.push({ text: 'OBS Name',  value: 'observerName',sortable: true},)
                }
                if (this.getShowCR("Observer Email")) {
                    hrs.push({ text: 'OBS Email',  value: 'observerEmail',sortable: true},)
                }
                if (this.getShowCR("Observer Phone")) {
                    hrs.push({ text: 'OBS Phne',  value: 'observerPhone',sortable: true},)
                }
                if (this.getShowCR("Observer Type")) {
                    hrs.push({ text: 'OBS Type',  value: 'observerType',sortable: true},)
                }
                if (this.getShowCR("Submitted Date")) {
                    hrs.push({ text: 'Sub Date',  value: 'submittedDate',sortable: true},)
                }
                //party
                if (this.getShowCR("Party Name")) {
                    hrs.push({ text: 'PARTY NAME', value: 'partyName',sortable: true},)
                }
                if (this.getShowCR("Party Short Name")) {
                    hrs.push({ text: 'PARTY SHORT NAME', value: 'partyShortName',sortable: true},)
                }
                if (this.getShowCR("Party Code")) {
                    hrs.push({ text: 'PARTY CODE', value: 'partyCode',sortable: true},)
                }

                //Region
                if (this.getShowCR("Region Name")) {
                    hrs.push({ text: 'REGION NAME', value: 'regionName',sortable: true},)
                } 
                if (this.getShowCR("Region Code")) {
                    hrs.push({ text: 'REGION CODE', value: 'regionCode',sortable: true},)
                }

                //District
                if (this.getShowCR("District Name")) {
                    hrs.push({ text: 'DISTRICT NAME', value: 'districtName',sortable: true},)
                } 
                if (this.getShowCR("District Code")) {
                    hrs.push({ text: 'DISTRICT CODE', value: 'districtCode',sortable: true},)
                }

                //Constituency
                if (this.getShowCR("Constituency Name")) {
                    hrs.push({ text: 'CONSTITUENCY NAME', value: 'constituencyName',sortable: true},)
                } 
                if (this.getShowCR("Constituency Code")) {
                    hrs.push({ text: 'CONSTITUENCY CODE', value: 'constituencyCode',sortable: true},)
                }

                //Ward
                if (this.getShowCR("Ward Name")) {
                    hrs.push({ text: 'WARD NAME', value: 'wardName',sortable: true},)
                } 
                if (this.getShowCR("Ward Code")) {
                    hrs.push({ text: 'WARD CODE', value: 'wardCode',sortable: true},)
                }

                //Centre
                if (this.getShowCR("Centre Name")) {
                    hrs.push({ text: 'CENTRE NAME', value: 'centreName',sortable: true},)
                } 
                if (this.getShowCR("Centre Code")) {
                    hrs.push({ text: 'CENTRE CODE', value: 'centreCode',sortable: true},)
                }

                  
                if (this.getShowCR("Votes")) {
                    hrs.push({ text: 'VOTES', value: 'votes',sortable: true},)
                }
                if (this.getShowCR("ACTION")) {
                    hrs.push({ text: 'ACTION',align: 'center', value: 'action',sortable: false })
                }
                return hrs
            },
            JOINED_results(){
                let resultsType = this.resultsType
                let results = this.results(resultsType)  
                let resultsDetails = this.resultsDetails(resultsType) 
                let joinedResults = this.not.JOIN_RESULTS(results,resultsDetails)  
                return joinedResults
            }, 
            paginedChartData(){
                let p = this.pagerGraph
                let data = this.chartData()
                let pager = this.not.pagination(data,p.page,p.size)   
                return pager.list
            },
            tableData(){ 
                let resultsType = this.resultsType
                let graph = this.selectedGraph() 
                let items = []
                if (graph==="Candidates") {
                    items =this.not.CALCULATE_CANDIDATES_RESULTS(null,resultsType)  
                }else if (graph==="Regions") {
                    items =this.not.CALCULATE_REGIONS_RESULTS(resultsType)
                }else if (graph==="Districts") {
                    items =this.not.CALCULATE_DISTRICTS_RESULTS(resultsType)
                }

                let data = []
                if(!items){return []}
                items.forEach(it => {
                    data.push({
                        name:it.name,
                        value:it.votes
                    })
                });  
                return items
            }, 

            candidate_district_results(){
                return (candidate_code)=>{
                    let resultsType = this.resultsType
                    let allResults = this.JOINED_results
                    let res = this.not.CALCULATE_DISTRICTS_CANDIDATE_RESULTS(allResults,candidate_code,resultsType) 
                    if(!res){return null}
                    return res.sort(this.not.dynamicSort('votes'))
                }
            },
            candidate_results_by_location(){
                return (code)=>{
                    let resultsType = this.resultsType
                    let allResults = this.JOINED_results
                    let res =  this.not.CALCULATE_CANDIDATES_RESULTS_BY_LOCATION(allResults,resultsType,this.selectedGraph(),code) 
                    if(!res){return null}
                    return res.sort(this.not.dynamicSort('votes'))
                }
            }
        },
        //------------methods---------------
        methods: {  
            clicked(){ 
            },  
            notYesDialog(action){
                if (action) {
                    if (action.code ===pageName+'=ADD-RESULT') {
                         
                    }  
                }
            }, 
            //Chart
            chartData(){
                let resultsType = this.resultsType
                let results = this.JOINED_results
                let graph = this.selectedGraph() 
                let items = []
                if (graph==="Candidates") {
                    items =this.not.CALCULATE_CANDIDATES_RESULTS(null,resultsType)  
                }else if (graph==="Regions") {
                    items =this.not.CALCULATE_LOCATION_CANDIDATE_RESULTS(results,graph)
                }else if (graph==="Districts") {
                    items =this.not.CALCULATE_LOCATION_CANDIDATE_RESULTS(results,graph)
                }

                let data = []
                if(!items){return []}
                items.forEach(it => {
                    data.push({
                        name:it.name,
                        value:it.votes,
                        itemStyle: {color:it.party_color?it.party_color:null},
                        party_color:it.party_color?it.party_color:null,
                        ...it
                    })
                });   
                return data
            },
            
            costomizeXHeaderResults(){
                let gp = this.xHeader_graph
                if (!gp) { return}
                let name = ""
                gp.forEach(element => {
                    let type = element.type
                    let show = element.show

                    if (type==="results") {
                        if (show) {
                            name = element.name
                        }
                    }

                });
                if (name==="Regions") {
                    this.xHeader_results=[ 
                        {id:1,name:"General",title:true},
                        {id:0,name:"Number",show:true},
                        {id:0,name:"Votes",show:true}, 
                        {id:26,name:"ACTION",show:true},  

                        {id:1,name:"Region",title:true},
                        {id:0,name:"Region Name",show:true}, 
                        {id:0,name:"Region Code",show:false},  
        
                        {id:1,name:"More..",title:true},
                        {id:0,name:"Added By",show:false}, 
                        {id:0,name:"Added At",show:false}, 
                        {id:0,name:"Updated At",show:false},
                        
                    ]
                }else if (name==="Districts") {
                    this.xHeader_results=[ 
                        {id:1,name:"General",title:true},
                        {id:0,name:"Number",show:true},
                        {id:0,name:"Votes",show:true}, 
                        {id:26,name:"ACTION",show:true}, 

                        {id:1,name:"District",title:true},
                        {id:0,name:"District Name",show:true}, 
                        {id:0,name:"District Code",show:false},   

                        {id:1,name:"More",title:true},
                        {id:0,name:"Added By",show:false}, 
                        {id:0,name:"Added At",show:false}, 
                        {id:0,name:"Updated At",show:false},
                        
                    ]
                }else if (name==="Candidates") {
                    this.xHeader_results=[ 
                        {id:1,name:"General",title:true},
                        {id:0,name:"Number",show:true},
                        {id:0,name:"Votes",show:true}, 
                        {id:26,name:"ACTION",show:true}, 

                        {id:1,name:"Candidate",title:true},
                        {id:0,name:"Candidate Name",show:true}, 
                        {id:0,name:"Candidate Code",show:false}, 
                        {id:0,name:"Candidate Gender",show:true},

                        {id:1,name:"Party",title:true},
                        {id:0,name:"Party Name",show:false}, 
                        {id:0,name:"Party Short Name",show:true}, 
                        {id:0,name:"Party Code",show:false},  
                         
                        {id:1,name:"More",title:true},
                        {id:0,name:"Added By",show:false}, 
                        {id:0,name:"Added At",show:false}, 
                        {id:0,name:"Updated At",show:false},
                        
                    ]
                }
                
                 
            }, 
            onCustomizeGraph(item,i){
                let xHeader_graph = this.xHeader_graph
                if (!item) { return}
                if (!xHeader_graph) {return}
                let type = item.type
                xHeader_graph.forEach(it => {
                    if (it.type===type) {
                        it.show = false 
                    }
                });
                xHeader_graph[i].show = true
                this.costomizeXHeaderResults()
            },
            selectedGraph(name,type="results"){
                let xHeader_graph = this.xHeader_graph 
                if (!xHeader_graph) {return null}

                let returne = null
                if (name) {
                    xHeader_graph.forEach(it => {
                       if (it.name==name) {
                           returne = it.show
                       }
                    });  
                }else{
                    xHeader_graph.forEach(it => {
                       if (it.show) {
                           if (it.type===type) {
                               if (type==="results") {
                                   returne = it.name  
                               }else if (type==="unit") {
                                   returne = it.name  
                               }else{
                                   returne =this.not.CONVERT_STRING_TO_INT(it.name) 
                               }
                           }
                       }
                    }); 
                }
                return returne
            },
            //filter
            filterResults(item){ 
                if(!item){return []}
                let code = item.code
                let results = this.JOINED_results
                if(!code){return []}
                if(!results){return []}
                 let candResults = null
                if (this.selectedGraph()==="Candidates") {
                    candResults = results.filter(it=>{
                        return it.candidateCode == code
                    }) 
                } else if (this.selectedGraph()==="Regions") {
                    candResults = results.filter(it=>{
                        return it.regionCode == code
                    }) 
                } else if (this.selectedGraph()==="Districts") {
                    candResults = results.filter(it=>{
                        return it.districtCode == code
                    }) 
                } 

                return candResults
            },
            getShowCR(name){   
                let ct = this.customResults 
                if (!ct) {return null}
                let ctItem = ct.find(item=>{
                    return item.name == name
                })
                if (!ctItem) {return null}
                // ctItem.show
                return ctItem.show
            },

            //Heades
            headerss(type){
                 
                let hds = null
                if (type === 'graph') {
                    hds = this.xHeader_graph
                }if (type === 'results') {
                    hds = this.xHeader_results
                }else {
                    hds = this.xHeader_graph
                } 
                let headers = this.not.TABLE_HEADERS(hds) 
                return headers
            },

            viewItem(item){
                let selected = this.selectedGraph()
                if (this.not.TEXT_UP(selected)===this.not.TEXT_UP("candidates")) {
                    this.viewItemCandidate(item)
                }else if (this.not.TEXT_UP(selected)===this.not.TEXT_UP("regions")) {
                    this.viewItemRegion(item)
                }else if (this.not.TEXT_UP(selected)===this.not.TEXT_UP("districts")) {
                    this.viewItemDistrict(item)
                } 
            },
            viewItemCandidate(item){ 
                this.selectedViewItem = item
                this.dialog_candidate=true 
            },
            viewItemRegion(item){ 
                this.selectedViewItem = item
                this.dialog_region=true 
            },
            viewItemDistrict(item){ 
                this.selectedViewItem = item
                this.dialog_district=true 
            },
            //-----------------[PAGE CONTRAL]---------
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 
                    this.costomizeXHeaderResults()

                    //Check proccess 
                    if (ps) {
                        let logging = ps.find(process=>{
                            return process.name == 'logging'
                        })
                        let getting = ps.find(process=>{
                            return process.name == 'getting/results'
                        })
                        let adding = ps.find(process=>{
                            return process.name == 'adding/results'
                        })  
                        let updating = ps.find(process=>{
                            return process.name == 'updating/results'
                        })  
                        let deleting = ps.find(process=>{
                            return process.name == 'deleting/result'
                        }) 
                        let setting = ps.find(process=>{
                            return process.name == 'setting/results'
                        }) 

                        if (logging) {
                            this.page_show =false
                            this.not.notDialogP(true,true,'Logging...')
                        }else{ 
                            this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                        }

                        if (getting) {
                            this.page_show_results =false
                            this.not.notDialogP(true,false,'Loading...')
                        }else{ 
                            this.page_show_results =true
                        }

                        
                        if (adding) {
                            this.not.notDialogP(true,false,'Saving...')
                            this.input.loading = true
                        }else{ 
                        } 
                        if (updating) {
                            this.not.notDialogP(true,false,'Saving...')
                            this.input.loading = true
                        }else{ 
                        }   
                        if (deleting) {
                            this.not.notDialogP(true,false,'Deleting...') 
                        }else{ 
                        }  

                        if (setting) {
                            this.not.notDialogP(true,false,'Uploading...')
                            this.input.loading = true
                        }else{ 
                        } 

                        //IF ALL DONE
                        if (ps.length===0) { 
                            this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                            this.not.notDialogP(false)
                        }
                    }else{
                        this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                        this.not.notDialogP(false)
                    }

                    //check response
                    if (res.res==='adding/results/successful') { 
                        this.not.notDialog(true,true,'Successful','Result successfully added.','','OK',{code:pageName+'=ADD-RESULTS-SUCCESS'})
                        this.input.loading = false
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='adding/results/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while adding the result. Make sure your password is correct or contact admin.','','OK',{code:pageName+'=ADD-RESULTS-ERROR'})
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }  
                },t)
            }
        }, 
        watch: {
            us(v){
                
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
    }  
</script>
 
 
